function HeroClouds() {
    return (
        <div class="cloud-container">
            <div class="clouds"></div>
        </div>
    )
}

export default HeroClouds